export default {
      id: "i-cart-white-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "img/sprite.svg#i-cart-white",
      toString: function () {
        return this.url;
      }
    }